export const getPaceTaskViewValue = (
  taskName: string,
  dateType: string,
  paceTaskId?: string,
): string =>
  `${taskName}${paceTaskId ? ` (${paceTaskId})` : ``} - ${dateType
    .replace(/pace|date/gi, (str: string) => ` ${str} `)
    .trim()}`;
